import { render, staticRenderFns } from "./ModalChannel.vue?vue&type=template&id=e4706922&scoped=true"
import script from "./ModalChannel.vue?vue&type=script&lang=js"
export * from "./ModalChannel.vue?vue&type=script&lang=js"
import style0 from "./ModalChannel.vue?vue&type=style&index=0&id=e4706922&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4706922",
  null
  
)

export default component.exports